import React from 'react'
import PropTypes from 'prop-types'
import { fetchLmsCourses } from '../../actions'

export default class CreateTool extends React.Component {
  static contextTypes = {
    store: PropTypes.object,
  }

  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
    let { coursenum } = this.context.store.getState()
    this.context.store.dispatch(fetchLmsCourses(coursenum))
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { coursenum, courseList, canvasCoursenum } =
      this.context.store.getState()
    let canvasCourse
    let canvasName = ''
    let externalLinkEndpoint = `/links/client_canvas.create_external_launch_tool/${coursenum}/`
    if (courseList && courseList.length !== 0 && canvasCoursenum) {
      let canvasCourseMap = courseList.reduce((memo, c) => {
        memo[c.id] = c
        return memo
      }, {})
      canvasCourse = canvasCourseMap[canvasCoursenum]
      canvasName = canvasCourse.name
    }

    return (
      <div className="card-myed">
        <div className="canvas-flex-wrapper">
          <div className="wrapper control-box">
            <h3>4. Create Link</h3>
            <p>
              Click the button below to create a new link to MyEducator in your
              Canvas course <span className="bold">{canvasName}</span>
            </p>

            <div className="canvas-flex-wrapper justify-left">
              <div className="nav-button-container">
                <a
                  href={externalLinkEndpoint}
                  className="btn btn-primary btn-myed btn-primary-myed"
                >
                  Create Link <div className="fas fa-chevron-right ml-2" />
                </a>
              </div>
            </div>
          </div>
          <div className="canvas-statusmarker-container">
            <img src="/static/instructor/media/canvas-logo-lms.png" />
          </div>
        </div>
      </div>
    )
  }
}
